
import { CREATE_GAMEFACT, 
    DELETE_GAMEFACT, 
    UPDATE_GAMEFACT, 
    UPDATE_TIMER, 
    DELETE_ARTICLE,
    UPDATE_ARTICLE,
    CREATE_ARTICLE, 
    DELETE_NOTATION,
    UPDATE_NOTATION,
    CREATE_NOTATION,
    CREATE_PLAYER,
    UPDATE_COMPOSITION,
    UPDATE_INFOMATCH,
    CREATE_SURVEY,
    UPDATE_SURVEY,
    DELETE_SURVEY,
    CREATE_QUIZZ,
    UPDATE_QUIZZ,
    DELETE_QUIZZ,
    UPDATE_PLAYER,
    AUTOSCORE_GAMEFACTS,
    UPDATE_INFOACTULIVE,
    CREATE_QUESTIONBOX,
    UPDATE_QUESTIONBOX,
    DELETE_QUESTIONBOX

} from '../constants/actionTypes.js'
// Action creator

export const resolveMessage = (match, addNotification)  => async (dispatch, getState) => {

    if(!match.actionDetail){
        console.warn('Message inattendu')
    }else{
        const {idMatch, actionDetail, collectorServerTime} = match
        const {action, payload} = actionDetail


        // On remet le collectorServertime à l'heure
        //dispatch({ type : EDIT_COLLECTOR_TIMESTAMP, payload : {collectorServerTime}})

        let notificationConfig = {
            title: '', 
            type: 'info',
            description: '', 
            link: ''
        };

        switch(action){
            case "addGameFact":
                dispatch({ type : CREATE_GAMEFACT, payload})
                notificationConfig = {
                    title: 'Nouveau fait de jeu',
                    description: `Un nouveau fait de jeu a été ajouté : ${payload.type}`,
                    type: 'success',
                };
            break;
            case "autoScoreGameFact":
                dispatch({ type : AUTOSCORE_GAMEFACTS, payload})
            break;
            case "updateGameFact":
                dispatch({ type : UPDATE_GAMEFACT, payload})
                notificationConfig = {
                    title: 'Modification fait de jeu',
                    description: `Un fait de jeu a été modifié : ${payload.type}`,
                    type: 'success',
                };
            break;
            case "deleteGameFact":
                dispatch({ type : DELETE_GAMEFACT, payload})
                notificationConfig = {
                    title: 'Suppression fait de jeu',
                    description: `Un fait de jeu a été supprimé`,
                    type: 'success',
                };
            break;
            case "addNotation":
                dispatch({ type : CREATE_NOTATION, payload})
            break;
            case "updateNotation":
                dispatch({ type : UPDATE_NOTATION, payload})
            break;
            case "deleteNotation":
                dispatch({ type : DELETE_NOTATION, payload})
            break;
            case "addSurvey":
                dispatch({ type : CREATE_SURVEY, payload})
            break;
            case "updateSurvey":
                dispatch({ type : UPDATE_SURVEY, payload})
            break;
            case "deleteSurvey":
                dispatch({ type : DELETE_SURVEY, payload})
            break;
            case "addQuizz":
                dispatch({ type : CREATE_QUIZZ, payload})
            break;
            case "updateQuizz":
                dispatch({ type : UPDATE_QUIZZ, payload})
            break;
            case "deleteQuizz":
                dispatch({ type : DELETE_QUIZZ, payload})
            break;
            case "addQuestionBox":
                dispatch({ type : CREATE_QUESTIONBOX, payload})
            break;
            case "updateQuestionBox":
                dispatch({ type : UPDATE_QUESTIONBOX, payload})
            break;
            case "deleteQuestionBox":
                dispatch({ type : DELETE_QUESTIONBOX, payload})
            break;
            case "addArticle":
                dispatch({ type : CREATE_ARTICLE, payload})
            break;
            case "updateArticle":
                dispatch({ type : UPDATE_ARTICLE, payload})
            break;
            case "deleteArticle":
                dispatch({ type : DELETE_ARTICLE, payload})
            break;
            case "updateTimer":
                dispatch({ type : UPDATE_TIMER, payload})
            break;
            case "updateComposition":
                dispatch({ type : UPDATE_COMPOSITION, payload})
            break
            case "updateInfoMatch":
                dispatch({ type : UPDATE_INFOMATCH, payload})
            break
            case "createPlayer":
                dispatch({ type : CREATE_PLAYER, payload : {idMatch, player : payload}})
            break;
            case "updatePlayer":
                dispatch({ type : UPDATE_PLAYER, payload : {idMatch, player : payload}})
            break;
            case "updateActuLive":
                dispatch({type : UPDATE_INFOACTULIVE, payload})
            break;
            default :
                console.error("Action not managed for sockets => ", action)

        }

        // Ajoute la notification avec les informations extraites
        if (notificationConfig.description) {
            addNotification(notificationConfig);
        }
    }
}